import { Chip, SxProps } from '@mui/material';
import { TAX_TYPE } from 'commons/constants';
import { addLeadingZeros } from 'commons/utils';

interface AddendumValueProps {
  idPedidoOriginal: number;
  tipoAdendo: 1 | 2;
  taxaAdendo: 1 | 2;
  sx?: SxProps;
}

export const AddendumValue: React.FC<AddendumValueProps> = ({
  idPedidoOriginal,
  tipoAdendo,
  taxaAdendo,
  sx,
}: AddendumValueProps) => {
  const percentageTax = taxaAdendo ? TAX_TYPE[taxaAdendo] : null;

  const typeAddendum = {
    1: 'Taxa de cancelamento',
    2: 'Extensão de jornada',
  };

  const typeText = typeAddendum[tipoAdendo];

  return (
    <Chip
      label={`${typeText} ${percentageTax} • Pedido ${addLeadingZeros(idPedidoOriginal, 6)}`}
      sx={{ height: 24, width: '100%', maxWidth: 300, ...sx }}
    />
  );
};
